<template>
  <div>
    <div class="fm-flex fm-rela">
      <div
        style="
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          cursor: pointer;
        "
        @click="showPopover = true"
      ></div>
      <el-input
        :value="getSelectLabel"
        placeholder="请选择客户"
        style="width: 400px"
        suffix-icon="el-icon-arrow-right"
        readonly
      ></el-input>
    </div>
    <el-dialog
      title="选择客户"
      append-to-body
      modal-append-to-body
      width="1100px"
      close-on-click-modal
      close-on-press-escape
      :visible.sync="showPopover"
    >
      <el-form inline :model="searchData">
        <el-form-item>
          <el-input
            placeholder="编号/名称/联系方式/地址/备注"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 250px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="客户分组">
          <CustomerGroupSelect
            :multiple="false"
            v-model="searchData.customerGroupId"
            @change="changeAndSearch"
          ></CustomerGroupSelect>
        </el-form-item>
        <el-form-item label="客户类型">
          <CustomerTypeSelect
            :multiple="false"
            v-model="searchData.customerTypeId"
            @change="changeAndSearch"
          ></CustomerTypeSelect>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
            :loading="searchLoading"
          >
            查询
          </el-button>
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="resetAndSearch"
            :loading="searchLoading"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-form inline v-hasPermi="['customer:manage:add']">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-plus"
          @click="showEditDialog()"
          v-hasPermi="['customer:manage:add']"
        >
          新增客户
        </el-button>
      </el-form>
      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        ref="refsTable"
        @sort-change="sortChange"
        max-height="400px"
      >
        <el-table-column
          prop="customerNo"
          label="编号"
          width="130"
          align="center"
          header-align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="150"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="联系方式"
          width="150"
          align="center"
          header-align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="联系地址"
          min-width="250"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="customerGroup.name"
          label="客户分组"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.customerGroup ? scope.row.customerGroup.name : "——" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="customerType.name"
          label="客户类型"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.customerType ? scope.row.customerType.name : "——" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="250"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-fmtype="scope.row.remark ? '' : 'warning'">{{
              scope.row.remark || "——"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-thumb"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="hideclose"
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      id="editDialog"
      :title="editInfo && editInfo.id ? '修改客户' : '新增客户'"
      width="500px"
      append-to-body
      modal-append-to-body
      close-on-click-modal
      close-on-press-escape
      :visible.sync="editDialogVisible"
    >
      <el-form
        :model="editInfo"
        label-position="right"
        label-width="100px"
        ref="editFormRef"
        :rules="{
          name: $ruleUtil.name('客户名称'),
          phoneNumber: $ruleUtil.phoneNumber(),
          address: $ruleUtil.simple({
            fieldName: '联系地址',
            required: true,
            min: 2,
            max: 200,
          }),
          customerTypeId: $ruleUtil.simple({
            fieldName: '客户类型',
            handleType: '选择',
            required: false,
          }),
          customerGroupId: $ruleUtil.simple({
            fieldName: '客户分组',
            handleType: '选择',
            required: false,
          }),
          remark: $ruleUtil.simple({
            fieldName: '备注',
            required: false,
            max: 200,
          }),
        }"
        v-if="editInfo"
      >
        <el-form-item label="客户编号" v-if="editInfo.id">
          {{ editInfo.customerNo }}
        </el-form-item>
        <el-form-item label="客户名称" prop="name">
          <el-input
            v-model="editInfo.name"
            placeholder="请输入客户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="当前余额" v-if="editInfo.id">
          <div class="fm-justifycenter" style="height: 32px">
            <FmAmount :amount="editInfo.balanceAmount"></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="联系方式" prop="phoneNumber">
          <el-input
            v-model="editInfo.phoneNumber"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            v-model="editInfo.address"
            placeholder="请输入联系地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户分组" prop="customerGroupId">
          <CustomerGroupSelectDialog
            :value="customerGroup"
            @select="selectCustomerGroup"
          ></CustomerGroupSelectDialog>
        </el-form-item>
        <el-form-item label="客户类型" prop="customerTypeId">
          <CustomerTypeSelectDialog
            :value="customerType"
            @select="selectCustomerType"
          ></CustomerTypeSelectDialog>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            v-model="editInfo.remark"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="冻结状态" prop="frozen">
          <el-radio-group v-model="editInfo.frozen">
            <el-radio :label="false">
              <span v-fmtype="'success'">未冻结</span>
            </el-radio>
            <el-radio :label="true">
              <span v-fmtype="'danger'">已冻结</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editInfo = null">取 消</el-button>
        <el-button type="primary" @click="edit">
          {{ editInfo && editInfo.id ? "修 改" : "新 增" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomerSelect",
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    getSelectLabel() {
      if (this.value && this.value.name) {
        return this.value.customerNo + " " + this.value.name;
      }
    },
    editDialogVisible: {
      get() {
        return !!this.editInfo;
      },
      set(val) {
        if (!val) {
          this.editInfo = null;
        }
      },
    },
  },
  watch: {
    showPopover: {
      handler(newVal, val) {
        if (newVal) {
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      showPopover: false,

      searchLoading: false,
      searchData: {
        searchInputValue: null,
        customerGroupId: null,
        customerTypeId: null,
        minBalance: null,
        maxBalance: null,
      },

      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["customerNo", "name", "phoneNumber", "address", "remark"],
            quickSearchValue: null,
          },
        ],
        customerGroupId: null,
        customerTypeId: null,
        minBalance: null,
        maxBalance: null,
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},

      editInfo: null,
      customerGroup: {},
      customerType: {},
    };
  },

  mounted() {},

  methods: {
    selectCustomerGroup(item) {
      if (item) {
        this.editInfo.customerGroupId = item.id;
        this.customerGroup = item;
      } else {
        this.editInfo.customerGroupId = null;
        this.customerGroup = {};
      }
    },
    selectCustomerType(item) {
      if (item) {
        this.editInfo.customerTypeId = item.id;
        this.customerType = item;
      } else {
        this.editInfo.customerTypeId = null;
        this.customerType = {};
      }
    },

    select(item) {
      this.$emit("select", item);
      this.showPopover = false;
    },
    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.customerGroupId = this.searchData.customerGroupId;
      this.searchParam.customerTypeId = this.searchData.customerTypeId;
      this.searchParam.minBalance = this.searchData.minBalance;
      this.searchParam.maxBalance = this.searchData.maxBalance;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.customer_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },

    async showEditDialog() {
      this.editInfo = {
        name: null,
        phoneNumber: null,
        address: null,
        customerTypeId: null,
        customerGroupId: null,
        remark: null,
        frozen: false,
      };
      this.customerGroup = {};
      this.customerType = {};
    },

    async edit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.editInfo.id
          ? await this.$api.customer_update(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "修改中...",
              },
            })
          : await this.$api.customer_addNew(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "新增中...",
              },
            });
        if (requestRes && requestRes.success) {
          this.editInfo = null;
          this.customerGroup = {};
          this.customerType = {};
          this.search();
        }
      });
    },
  },
};
</script>

<style scoped>
/* 解决切换分页会出现一个关闭图标 */
.hideclose /deep/ .el-icon-circle-close {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/CustomerSelect.vue